
















import { defineComponent, ref, watch } from "vue";
import useSaveSearchButton from "@/composition/useSaveSearchButton";
import CdkFilterFormProvider from "@/components/CdkFilterForm/CdkFilterFormProvider.vue";

export default defineComponent({
  components: { CdkFilterFormProvider },
  setup() {
    const { showFilterDialog, setShowFilterDialog } = useSaveSearchButton();

    const dialog = ref<any>(null);

    watch(showFilterDialog, newVal => {
      if (newVal && dialog.value) {
        // eslint-disable-next-line no-unused-expressions
        (dialog.value.$el as HTMLElement).querySelector<HTMLInputElement>("[autofocus]")?.focus();
      }
    });

    return { dialog, showFilterDialog, setShowFilterDialog };
  }
});
